import { css } from 'linaria';

export const contentStyle = css`
  position: relative;
  margin: var(--space-250) 0;
`;
